var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.56006 14.6311L7.5 8.69112V10.8136L2.61756 15.6886C2.36256 15.6211 2.13006 15.4861 1.94256 15.3061C1.76256 15.1186 1.62756 14.8861 1.56006 14.6311Z",
    fill: "#696F88"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 2.91002L1.5 8.90997V11.0325L7.5 5.03252V2.91002Z",
    fill: "#696F88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.25C2.175 2.25 1.5 2.925 1.5 3.75V5.25L4.5 2.25H3Z",
    fill: "#696F88"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.21753 15.75L7.5 15.75V14.4676L6.21753 15.75Z",
    fill: "#696F88"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0.75H9V17.25H7.5V0.75Z",
    fill: "#696F88"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 5.25V3.75L13.5 3.75V2.25H15V3.75L16.5 3.75V5.25H15V12.75H16.5V14.25H15V15.75H13.5V14.25H10.5V12.75H13.5V5.25L10.5 5.25Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViIcon);
export default __webpack_public_path__ + "static/media/vi_icon.91f4500e94185fbb43b71b6e2b48dcc6.svg";
export { ForwardRef as ReactComponent };